/**
 电站运行看板-订单数据--故障率TOP20终端设备
 */
import React, { Component } from "react";
// import Echarts from "echarts";
import ScGridTable from "@/components/display/table/gridTableCore";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import { triggerDownloadFiles } from "@/utils/utils";
import { queryOrderStub } from "@/fetch/fetchApi";
// import fetchHandler from "@/fetch/fetchHandler";
import FaultRateStubModal from "./detail/faultRateStub";
import { Spin, Button } from "antd";
import PropTypes from "prop-types";
// import ExportJsonExcel from "js-export-excel";
// import { QuestionCircleFilled } from "@ant-design/icons";
import { initModals } from "@/state/action/comAction";
import RefreshGrid from "@/utils/refreshGrid";

class Top20FaultRate extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      areaList: [],
      quanguoCityArry: [],
      //   btnType: 1, // 按钮状态。 1图2表
      // tableConfig: null,
      exporting: false,
    };
    // 定义modals
    this.modalConfig = [
      {
        key: "faultRateStubModal",
        width: 800, // 自定义模态框宽度
        title: "高故障率终端", // 模态窗口的标题
        content: FaultRateStubModal, // 自定义 jsx内容
      },
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 初始化页面方法
   */
  componentWillMount() {
    // 默认加载
    this.initTableConfig(this.props.modalParam);
  }

  handleClick = async () => {
    // console.log("this.props.modalParam****export**", this.props.modalParam);

    this.setState({
      exporting: true,
    });
    await triggerDownloadFiles(
      "kanban/order/stub/export",
      {
        ...this.props.modalParam,
      },
      "故障率TOP20设备终端导出",
      ".xlsx",
      "get",
    );
    this.setState({
      exporting: false,
    });
  };

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentDidUpdate(prevProps) {
    if (prevProps.modalParam !== this.props.modalParam) {
      this.initTableConfig(this.props.modalParam);
      RefreshGrid(this.context.store, "top20FaultRateTable", this.props.modalParam);
    }
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  initTableConfig(params) {
    console.log("this.props.modalParam****export**", this.props.modalParam);
    console.log("params******", params);
    this.setState({
      tableConfig: {
        tableKey: "top20FaultRateTable",
        tableColumns: [
          {
            name: "设备编号",
            colType: "textCol",
            align: "center",
            render: (row) => {
              return (
                <a
                  onClick={(e) => {
                    this.openTab(
                      {
                        // cityIds: this.state.param.cityIds,
                        // provinceIds: this.state.param.provinceIds,
                        // stubType: this.state.param.stubType,
                        // operationMode: this.state.param.operationMode,
                        stubId: row.stubId,
                      },
                      {
                        key: "0102",
                        titleText: "公充设备查询",
                      },
                    );
                  }}>
                  {row.stubId}
                </a>
              );
            },
          },
          {
            name: "所属场站",
            key: "stubGroupName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单数",
            key: "totalNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "异常订单数",
            // key: "error_num",
            colType: "textCol",
            align: "center",
            render: (row) => {
              return (
                <a
                  onClick={(e) => {
                    this.context.store.dispatch(
                      initModals("faultRateStubModal", {
                        stubId: row.stubId,
                        ...params,
                      }),
                    );
                  }}>
                  {row.errorNum}
                </a>
              );
            },
          },
          {
            name: "成功订单数",
            key: "successNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障率",
            key: "faultRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return text ? `${text}` : "-";
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...params,
        },
        dataApi: queryOrderStub,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className="section">
          <div className="title-box" style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="title" style={{ marginRight: "5px" }}>
                故障率TOP20设备终端
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                loading={this.state.exporting}
                onClick={this.handleClick}
                type="primary"
                style={{ margin: "5px" }}>
                导出
              </Button>
            </div>
          </div>
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
      </Spin>
    );
  }
}

export default Top20FaultRate;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/top20FaultRate.js